export interface AppDownload {
  ItemId: number;
  RegionId?: number;
  Type: number;
  Year: number;
  Month: number;
  Value: number;
  Note: string;
  CreateId: number;
  CreateTime: string;
  UpdateId: number;
  UpdateTime: string;
}

export interface AppDownloadEntities {
  AppDownloadNode: AppDownload[];
  start_date: string;
  end_date: string;
}

export interface AppDownloadParam {
  year: number;
  region: number;
  idata: AppDownloadInserData[];
  adata: AppDownloadInserData[];
}

export interface AppDownloadInserData {
  month: number;
  value: number;
}
